import React from 'react'
import { TableColumn } from '../../../components/_EOS/GenericTable/types'
import { formatExpirationDate } from '../../../utils/dateHelper'
import { DispatchOtDetail } from '../entities/DispatchOt'
import { Typography, Box } from '@mui/material'
import {
  Image as ImageIcon,
  NotInterested as NotInterestedIcon,
} from '@mui/icons-material'

const NoImageIndicator = () => {
  // Opción 1: Icono de imagen con indicador de no disponible (recomendada)
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      style={{ color: '#666', minHeight: 50 }}
    >
      <Box position="relative" display="inline-flex" alignItems="center">
        <ImageIcon style={{ fontSize: 24, color: '#ccc' }} />
        <NotInterestedIcon
          style={{
            fontSize: 16,
            color: '#f44336',
            position: 'absolute',
            right: -4,
            top: -4
          }}
        />
      </Box>
      <Typography variant="caption" style={{ fontSize: 10, color: '#999', marginTop: 2 }}>
      </Typography>
    </Box>
  )
}

export const generateTableColumnsDispatchOt = (): TableColumn<DispatchOtDetail>[] => {
  return [
    {
      key: 'url',
      title: 'Imagen',
      sortable: false,
      width: 80,
      render: (value) => {
        const imageUrl = (value as string)?.trim()

        if (!imageUrl) {
          return <NoImageIndicator />
        }

      return React.createElement('img', {
          src: imageUrl,
          alt: 'Producto',
          style: { width: 50, height: 50, objectFit: 'cover' as const }

        })
      }
    },
    {
      key: 'sku',
      title: 'SKU',
      sortable: true
    },
    {
      key: 'skuName',
      title: 'Nombre SKU',
      sortable: false
    },
    {
      key: 'quantity',
      title: 'Cantidad',
      sortable: false
    },
    {
      key: 'packSkuDun',
      title: 'Pack SKU DUN',
      sortable: false
    },
    {
      key: 'quantityDun',
      title: 'Cantidad DUN',
      sortable: false
    },
    {
      key: 'unitsWithoutPacks',
      title: 'Unidades Sin Packs',
      sortable: false
    },
    {
      key: 'isInRecall',
      title: 'En Recall',
      sortable: false,
      render: (value) => (value as boolean) ? 'Si' : 'No'
    },
    {
      key: 'batch',
      title: 'Lote',
      sortable: false,
      render: (_, row) => row.batch?.batchNumber || 'N/A'
    },
    {
      key: 'batch',
      title: 'Fecha de Vencimiento',
      sortable: false,
      render: (_, row) =>
        formatExpirationDate(row.batch?.expirationDate, 'dd-MM-yyyy')
    }
  ]
}

// Mantenemos la función anterior para compatibilidad si es necesaria en otros lugares
export const generateTableHeadersDispatchOt = generateTableColumnsDispatchOt
